import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const ClientAndPatient = forwardRef<SVGSVGElement, SvgIconProps>(
  function ClientAndPatient(props, ref) {
    return (
      <SvgIcon ref={ref} {...props}>
        <path d="M15 20.11c-.1-2.29-1.63-4.11-3.5-4.11-1.86 0-3.38 1.8-3.5 4.07-1.56-.7-2.77-1.88-3.1-3.43-.65-3.05 3.04-6.44 6.47-6.96 2.44-.36 5.04 1.15 6.31 4.13 1.05 2.48.77 4.99-2.68 6.3zM5.88 9.13c.6 1.43-.09 2.94-1.13 3.16-1.04.22-2.39-.6-2.68-1.98-.3-1.37.08-2.99 1.12-3.21 1.04-.22 2.15.73 2.69 2.03zm3.9.24C8.7 9.3 7.6 8.13 7.66 6.74c.06-1.4.83-2.83 1.9-2.74 1.07.08 1.9 1.3 2.1 2.69.22 1.52-.83 2.77-1.9 2.68zm6.5-4.73c1.15-.25 1.92.66 1.96 1.91.05 1.38-1.23 2.89-2.38 3.14-1.16.25-2.22-.5-1.98-1.85.24-1.35 1.24-2.95 2.4-3.2zm2.63 5.69c.88-.74 2.2-1.02 2.78-.22.57.79.33 2.07-.4 2.99-.79 1-2.15.98-2.73.18-.58-.79-.53-2.22.35-2.95zm-5.3 2.52a2 2 0 10-4 0 2 2 0 004 0z" />
      </SvgIcon>
    )
  },
)

export default ClientAndPatient
